import { getWorkflow } from '@jira/project-settings__workflow-services-document/src/getApiPrefix.tsx';
import type { ApiGetWorkflowResponseWithUsages } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
// eslint-disable-next-line jira/import-whitelist
import {
	prefetchApiReadyMark,
	prefetchApiStartMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/react-resource-router';

export const fetchWorkflowDocument = async (
	{ match }: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
	isProjectScoped: boolean,
): Promise<ApiGetWorkflowResponseWithUsages> => {
	const { isAnonymous, cloudId } = tenantContext;

	if (isAnonymous || !match.params.workflowId) {
		const message = !match.params.workflowId
			? 'Workflow ID is not defined.'
			: "Workflows can't be edited in anonymous mode.";
		throw new Error(message);
	}

	try {
		setMark(prefetchApiStartMark);
		const workflowDocument = await getWorkflow(
			cloudId,
			{
				workflowId: match.params.workflowId,
			},
			{ checkForDrafts: !isProjectScoped },
		);
		setMark(prefetchApiReadyMark);
		return workflowDocument;
	} catch (error: unknown) {
		throw createResourceError(
			{
				component: 'spa.view.routes.admin-pages.workflows.workflow-document.getData',
				message: 'An error was thrown while prefetching workflow document data',
				name: 'ResourceError',
			},
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
			error as any,
		);
	}
};
